import { Link } from "react-router-dom";
import { ArrowUpRight, House } from "@phosphor-icons/react";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 md:px-10 py-20" data-testid="not-found-page">
      <Helmet>
        <title>404 — Page not found | OneTec</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="prerender-status-code" content="404" />
        <meta name="prerender-header" content="Location: /" />
      </Helmet>
      <div className="max-w-2xl text-center">
        <p className="font-display text-[24vw] md:text-[18vw] leading-none tracking-tighter text-ot-indigo">404</p>
        <h1 className="font-display text-3xl md:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
          This page <span className="bg-ot-peach border-2 border-ot-fg px-2">left the building.</span>
        </h1>
        <p className="mt-6 text-lg text-ot-fg/70">
          The link you followed is broken or the page no longer exists. Here's where to go next:
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="nb-btn" data-testid="404-home-btn">
            <House weight="bold" /> Back to home
          </Link>
          <Link to="/products" className="nb-btn nb-btn-ghost">
            Browse products <ArrowUpRight weight="bold" />
          </Link>
          <Link to="/contact" className="nb-btn nb-btn-ghost">
            Contact us <ArrowUpRight weight="bold" />
          </Link>
        </div>
        <div className="mt-12 grid sm:grid-cols-3 gap-3 text-left">
          <Link to="/services" className="nb-card p-4 hover:!shadow-[10px_10px_0px_var(--ot-peach)]">
            <p className="text-xs uppercase tracking-widest font-bold text-ot-indigo">01</p>
            <p className="font-display text-lg uppercase mt-1">Services</p>
            <p className="text-xs text-ot-fg/60 mt-1">Brand activation, event tech, AV rental</p>
          </Link>
          <Link to="/products" className="nb-card p-4 hover:!shadow-[10px_10px_0px_var(--ot-mint)]">
            <p className="text-xs uppercase tracking-widest font-bold text-ot-indigo">02</p>
            <p className="font-display text-lg uppercase mt-1">Products</p>
            <p className="text-xs text-ot-fg/60 mt-1">18 production-ready experiences</p>
          </Link>
          <Link to="/about" className="nb-card p-4 hover:!shadow-[10px_10px_0px_var(--ot-coral)]">
            <p className="text-xs uppercase tracking-widest font-bold text-ot-indigo">03</p>
            <p className="font-display text-lg uppercase mt-1">About</p>
            <p className="text-xs text-ot-fg/60 mt-1">22+ years of eventattitude</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
